//                     /\    .-" /
//                     /  ; .'  .' 
//                    :   :/  .'   
//                     \  ;-.'     
//        .--""""--..__/     `.    
//      .'           .'    `o  \   
//     /                    `   ;  
//    :      FINANDFIND  \      :  
//  .-;        -.         `.__.-'  
// :  ;          \     ,   ;       
// '._:           ;   :   (        
//     \/  .__    ;    \   `-.     
//      ;     "-,/_..--"`-..__)    
//      '""--.._:

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import riskReducer from '../../../store/reducers/riskReducer';
import { connect } from "react-redux";
import { translateStatsChartLabel } from '../../../utils/statsChartLabels';
import { compose } from "redux";
import {
  BarChart,
  Bar,
  XAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from 'recharts';

const AssetStatusMetric = ({ height, data }) => {
  const { t } = useTranslation();
  const safeHeight = height && height > 100 ? height : 300;

  // const data = [
  //   { type: 'Preventive', count: 12 },
  //   { type: 'Detective', count: 7 },
  //   { type: 'Corrective', count: 4 },
  // ];
  const [processedData, setprocessedData] = useState([]);
  const [totalControls, settotalControls] = useState(0);
  useEffect(() => {
    if (data) {
      setprocessedData(data)
      settotalControls(data.reduce((sum, item) => sum + item.count, 0))
    }
  }, [data]);

  return (
    <div
      className="w-full bg-white rounded-lg px-4 pt-0 pb-0 flex flex-col"
      style={{ height: safeHeight }}
    >
      <div className="text-sm mt-1 text-gray-800 mb-0">
       {t("assetManagement.statsPage.status")}
      </div>

      <div className="flex-grow">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={processedData}
            margin={{ top: 10, right: 0, left: 0, bottom: 0 }} // Tighter bottom
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="type"
              tick={{ fontSize: 10 }}
              tickFormatter={(v) => translateStatsChartLabel(v, t)}
            />
            <Tooltip
              formatter={(value, name) =>
                name === "count"
                  ? [value, t("assetManagement.statsPage.countLabel")]
                  : [value, translateStatsChartLabel(name, t)]
              }
            />
            <Bar dataKey="count" fill="#FED4AE" radius={[4, 4, 0, 0]}>
              <LabelList dataKey="count" position="center" fill="#0A4E62" fontSize={10} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
    ////console.log(state.asset.assets_stat_data)
    return {

        //token: state.auth.token,
        //departments: state.department.departments,
        //department_id: state.department.department_id
        data: state.asset.assets_stat_data.status
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(AssetStatusMetric);